import React from 'react'
import './Footer.css'
import {FaHome, FaPhone, FaMailBulk, FaFacebook, FaTwitter, FaLinkedin} from 'react-icons/fa'

const Footer = () => {
  return (
    <>
    <div className='footer'>
        <div className='footer-container'>
            <div className='left'>
                <div className='location'>
                    <FaHome size={20} style={{color:"#fff", marginRight: "2rem"}}/>
                    <div>
                        <p>302. mnr oaks, kasavanahalli,</p>
                        <p>bengaluru, karnataka, India</p>
                    </div>
                </div>
                <div className='phone'>
                    <h4><FaPhone size={20} style={{color:"#fff", marginRight:"2rem"}} />+91 8769351553</h4>
                </div>
                <div className='email'>
                    <h4><FaMailBulk size={20} style={{color:"#fff", marginRight:"2rem"}} />pankajmenariya1997@gmail.com</h4>
                </div>
            </div>
            <div className='right'>
                <h4>About Me</h4>
                <p>Efficient and curious software developer who will bring a keen mindset to learn different technology and understand the
products/services/requirements that is being worked upon . Inclined towards a role which will help me in enhancing my technical ability and
which expands beyond my current skillset along with career growth opportunities.</p>
                <div className='social'>
                <FaFacebook size={20} style={{color:"#fff", marginRight:"2rem"}} />
                <FaTwitter size={20} style={{color:"#fff", marginRight:"2rem"}} />
                <a href="https://www.linkedin.com/in/pankaj-menariya/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={20} style={{ color: "#fff", marginRight: "2rem" }} />
              </a>
                </div>
            </div>
        </div>
    </div>
    <p className='copyright'>Copyright &copy; 2023 - All Rights Reserved.</p>
    </>
  )
}

export default Footer